import React from 'react';
import ReactDOM from 'react-dom';
import SnackbarWrapper from './SnackbarWrapper';

const root = document.getElementById('root');

const Snackbar = props => ReactDOM.createPortal(<SnackbarWrapper {...props} />, root);

export default Snackbar;
